import { ResolverTag } from '@ps/web-core-enums';
import { Input } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import styles from './DeAnnaulAttestationAddressFullName.scss';
import {
  TXTCLI_Full_Name,
  TXTCLI_If_you_have_changed_your_nameX_ELL
} from './DeAnnualAttestationAddressFullName.messages.json';

const DeAnnualAttestationAddressFullName: React.FC = () => (
  <Input
    id="fullName"
    label={TXTCLI_Full_Name}
    disabled
    tooltip={[
      {
        ...TXTCLI_If_you_have_changed_your_nameX_ELL,
        values: {
          a: (msg: string) => (
            <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
          )
        }
      }
    ]}
    tooltipIconClassName={styles.tooltipIcon}
  />
);

export default DeAnnualAttestationAddressFullName;
